const colors = {
  red: "#EF476F",
  yellow: "#FFD166",
  green: "#06D6A0",
  blue: "#2DA0ED",
  dark: "#caced9",
  gray: "#e1e5f2",
  white: "white",
  black: "black",
  indigo300: "#A5B4FC",
};

const fonts = {
  small: 0.1,
  medium: 0.2,
  large: 0.3,
};

export { colors, fonts };
